import * as React from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { ReactNode } from 'react';
import { ConnectOrcidFormData } from './ConnectOrcidFormData';
import { OrcidGrandRightsForm } from './OrcidGrandRightsForm';
import { Mandant } from '../../../util/types';

interface Props {
  submit: (data: ConnectOrcidFormData) => void;
  mandant: Mandant;
}

export const OrcidNotLinked = ({submit, mandant}: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  return <div>
    <h3>{intl.formatMessage({ id: `settings.orcid.notLinked.headline` })}</h3>
    <p>{intl.formatMessage({ id: `settings.orcid.notLinked.infotext` })}</p>
    <OrcidGrandRightsForm revoked={false} submit={submit} mandant={mandant}/>
  </div>;
};
